// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","error":"Button_error__2nDvg","success":"Button_success__cnhtV","primary":"Button_primary__28VL_"};